<template>
  <div class="index">
    <!-- 背景图 -->
    <div class="Imgbg">
      <!-- 背景图上的内容 -->
      <div class="w1200 headbox">
        <div class="kuang" v-if="layerData.imgUrl">
          <img :src="layerData.imgUrl|toimg" />
        </div>
        <div class="kuang" v-else>
          <img :src="require('@/assets/lvshi.png')" />
        </div>
        <div class="name">{{layerData.name}}律师</div>
        <div class="info">
          <span v-for="(x,i) in lawyerData.bgImgTopinfo" :key="i">{{x.label}}：{{x.val}}</span>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="w1200 navBox">
      <li v-for="(x,i) in navList" :key="i" :class="{'navActive':navAc===x.key}" @click="clickNav(x)">{{x.label}}</li>
    </div>
    <!-- 律师信息 -->
    <div class="w1200 layerBox">
      <div class="left">
        
        <div v-if="routeInfo==='flzx'||routeInfo==='ajwt'">
          <div class="infobox">
            <p class="infoTitle">{{layerTitle}}</p>
            <div class="cont">
              <div class="form">
                <!-- 咨询表单 -->
                <el-form ref="layerForm" :model="layerForm" :rules="layerFormRules" label-width="80px">
                  <div>
                    <el-form-item v-for="(x,i) in lawyerData[routeInfo]" :key="i" :label="x.label">
                      <el-input v-if="x.type==='input'" v-model="layerForm[x.shuxing]" :placeholder="x.str"></el-input>
                      <el-input v-if="x.type==='textarea'" type="textarea" :rows="4" placeholder="请输入咨询内容,字数在1000字以内"  v-model="layerForm[x.shuxing]"> </el-input>
                      <el-select v-if="x.type==='select'" v-model="layerForm[x.shuxing]" placeholder="请选择">
                        <el-option v-for="x in $fuwuData.laytype1" :key="x" :label="x" :value="x"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <!-- 案件委托和法律咨询表单公用部分 -->
                  <el-form-item label="所在地区">
                    <div class="areaBox">
                      <el-select v-model="areaIds[0]" clearable @change="remoteMethod($event, 1)" placeholder="省">
                        <el-option v-for="x in province" :key="x.id" :label="x.name" :value="x.id"></el-option>
                      </el-select>
                      <el-select v-model="areaIds[1]" clearable @change="remoteMethod($event, 2)" placeholder="市">
                        <el-option v-for="x in city" :key="x.id" :label="x.name" :value="x.id"></el-option>
                      </el-select>
                      <el-select v-model="areaIds[2]" clearable @change="remoteMethod($event, 3)" placeholder="县">
                        <el-option v-for="x in county" :key="x.id" :label="x.name" :value="x.id"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                  <el-form-item label="手机号码" prop="phoneNumber">
                    <el-input v-model="layerForm.phoneNumber" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item class="codeinput" label="验证码" prop="phoneCode">
                    <el-input class="input" v-model="layerForm.phoneCode"></el-input>
                    <el-button class="btn" style="margin-left:30px" type="info" :disabled="sendCodeBtnSet.disabled" @click="sendCode()">{{sendCodeBtnSet.str}}</el-button>
                  </el-form-item>
                  <div class="subBox"><el-button type="danger" @click="submitHandler()">提交咨询</el-button> </div>
                </el-form>
              </div>
            </div>
          </div>
        </div>
        <div class="pingjia" v-else-if="routeInfo==='pinjia'">
          <div class="commentBox">
            <p class="title">用户评价</p>
            <div class="btnbox">
              <el-button
                v-for="(x,i) in pingjiaBtnArr" :key="i" type="danger" plain
                :class="{commentBtn:i==scoreIndex}" @click="fifterComment(i)">{{x.label}}</el-button>
            </div>
            <div class="databox">
              <p v-if="commentData.length===0">暂无评论数据</p>
              <div v-else>
                <el-table :data="commentData"  style="width: 100%">
                  <el-table-column v-for="(x,i) in commentInfo" :key="i" :label="x.label" :prop="x.val"></el-table-column>
                </el-table>
              </div>
            </div>
            <!-- 页码 -->
            <paging :pagesData="paging_data" @set_page_number="get_page_number"></paging>
          </div>
          <comments v-show="routeInfo==='pinjia'" :targetId="layerData.id" :commentNum="commentData.length" type="律师" @refresh="getCommentData"></comments>
        </div>
        <div v-else>
          <div class="infobox" v-for="(x,i) in lawyerData[routeInfo]" :key="i">
            <p class="infoTitle">{{x.title}}</p>
            <div class="cont" v-if="!x.videoSrc">{{x.label}}</div>
            <div class="cont" v-else>
              <video :src="x.videoSrc" controls="controls">您的浏览器不支持 video 标签。</video>
            </div>
          </div>
          <div class="infobox" v-if="routeInfo=='home'">
            <p class="infoTitle">互动交流</p>
            <div class="cont" style="font-size:16px">
              <el-input type="textarea" :rows="5" placeholder="文明上网，理性发言" v-model="flzxcont"></el-input>
              <el-button style="margin:20px 0px 15px 93%" type="danger" @click="rightFormSubmit(flzxcont,'互动交流')">发送</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- 律师基本信息 -->
        <div class="infobox" v-if="routeInfo==='home'">
          <p class="infoTitle">基本资料</p>
          <div class="cont">
            <li v-for="(x,i) in lawyerData.userInfo" :key="i">
              <span>{{x.title}}：{{x.val}}</span>
            </li>
          </div>
        </div>
        <contactCard :interactionShow="true" :complaintShow="true"></contactCard>
      </div>
    </div>
  </div>
</template>

<script>
// import mixins from '@/Mixins/mixin_3g48.js'
import contactCard from '@/views/showpage/components/contactcard' // 联系名片组件
import comments from '@/views/showpage/components/comments' // 评价表单组件
export default {
  components: { contactCard,comments },
  // mixins:[mixins],
  data() {
    const isPhone = (rule,value,callback) => {
      const reg=/^1[3|4|5|7|8][0-9]\d{8}$/
      if (!reg.test(value)) {callback(new Error('手机号码不符合规范'))
      } else {
        callback()
      }
    };
    return {
      layerFormRules: {
        phoneNumber: [
          { required: 'true', message: '手机号不能为空', trigger: 'blur' },
          { validator: isPhone,trigger:'blur'}
        ],
        phoneCode: [{ required: 'true', message: '验证码不能为空', trigger: 'blur' },]
      },
      layerData: {},
      layerTitle: '律师主页',
      flzxcont: '', // 暂时用于承接律师主页下面的我要咨询
      layerForm: {}, // 提交的表单对象

      province: [], // 表单里面的 省市县 的下拉框选项
      city: [],
      county: [],
      areaIds: [],

      sendCodeBtnSet: {
        codeTime: 180,
        disabled: false,
        str: '获取验证码'
      }, // 发送验证码按钮的设置

      navList: [ // 导航配置信息
        {label:'律师主页',key:'home'},
        {label:'法律咨询',key:'flzx'},
        {label:'案件委托',key:'ajwt'},
        {label:'视频简介',key:'video'},
        {label:'成功案例',key:'success'},
        {label:'用户评价',key:'pinjia'},
      ],
      navAc: 'home',

      lawyerData: {
        bgImgTopinfo: [], // 背景图下面的配置信息
        home: [], // 当前页面为主页时的配置信息
        video: [], // 当前页面为视频时的配置信息

        flzx: [ // 法律咨询表单配置
          {label:'咨询标题',type:'input',str:'请输入内容',shuxing:'title'},
          {label:'咨询内容',type:'textarea',str:'请输入内容',shuxing:'content'},
        ],
        ajwt: [ // 案件委托表单配置信息
          {label:'涉案标题',type:'input',str:'请输入内容',shuxing:'title'},
          {label:'涉案事实',type:'textarea',str:'请输入内容',shuxing:'content'},
          {label:'涉案类别',type:'select',str:'请输入内容',shuxing:'caseType'},
          {label:'涉案金额',type:'input',shuxing:'caseCash'},
        ],

        userInfo: [] // 右边的律师基本信息的配置
      },
      pingjiaBtnArr: [
        {label:'全部',score:'all'},
        {label:'好评',score:'5'},
        {label:'中评',score:'3'},
        {label:'差评',score:'1'},
      ],
      scoreIndex: 0, // 默认给评论分类中的全部 高亮显示
      commentData: [], // 评论数组
      commentInfo: [ // 评论数据表头
        {label:'用户名',val:'userName'},
        {label:'分数',val:'score'},
        {label:'评论内容',val:'content'},
        {label:'评论时间',val:'createTime'},
      ],
    }
  },
  computed: {
    // interactionShow() {
    //   return this.navAc === 'home'
    // }, // 右边的互动交流表单是否显示

    routeInfo() { return this.$route.query.key },
    provinceId() { return this.areaIds[0] },
    cityId() { return this.areaIds[1] }
  },
  watch: {
    routeInfo(val) {
      this.layerTitle = this.navList.find(x => this.navAc === x.key).label
      this.areaIds = [] // 当法律咨询和案件委托互相切换时，重置区域
      val === 'pinjia' ? this.getCommentData():''
    },
    provinceId(val) {
      if (val === '') {
        this.areaGet(0, 0)
      } else {
        this.areaGet(val, 1)
      }
    },
    cityId(val) {
      let areaId = this.areaIds[0]
      if (val === '') {
        this.areaGet(areaId, 1)
      } else {
        this.areaGet(val, 2)
      }
    },
    scoreIndex(val) {
      this.getCommentData()
    }
  },
  methods: {
    rightFormSubmit(content, title) {
      if (content === '') {
        this.$message.error('请填写内容后再提交！')
      } else {
        if (title === '互动交流') {
          console.log('内容', content)
          let rD = {
            userId: this.userInfo.id,
            targetId: this.layerData.ownerId,
            content,
          }
          this.$confirm('确定要留言此信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$api.util_create('hudong', rD).then(res => {
              if (res.data.status == 0) {
                this.$message.success('留言成功！')
              } else { this._status(res.data) }
            })
          }).catch(() => {})
        } else {//投诉
          console.log('内容', content, '律师',this.layerData, '公司',this.companyData, '详情',this.detailData)
          
          let userId = this.userInfo.id
          // let areaId = this.areaIds_x[this.areaIds_x.length - 1]
          let route = this.$route.name
          let targetId = this.companyId
          let subName = ''

          if (['detail','detailList'].includes(route) && !this.companyData) {
            this.$message.warning('企业信息不完善！')
            return
          } else {
            switch (route) {
              case 'detail':
                targetId = this.companyData.id || this.detailData.id
                subName = this.detailData.name
              break
              case 'detailList':
                targetId = this.companyData.id
                subName = this.companyData.o_name
              break
              case 'layerDetail':
                targetId = this.layerData.ownerId
                subName = this.layerData.name
              break
            }

            let rD = {
              // areaId,
              targetId,
              subName,
              userId,
              content,
            }
            console.log(rD)
            this.$confirm('确定要投诉此信息?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.util_create('tousu', rD).then(res => {
                if (res.data.status === 0) {
                  this.$message.success('投诉成功！')
                } else { this._status(res.data) }
              })
            }).catch(() => {})
          }
        }
      }
    },

    clickNav(obj) {//点击导航
      let url = '/layerDetail/?type=lvshi&id='+this.$route.query.id+'&key='+obj.key
      if (this.$route.fullPath !== url) {
        // this.scrollToTop(130)
        this.$router.replace(url)
      }
      this.navAc = obj.key
    },
    areaGet(areaId, index) {// 获取位置
    let rD = { areaId }
      this.$api.getPlace(rD).then(res => {
        if (res.data.status === 0 ) {
          let _R = JSON.parse(res.data.data)
          switch(index) {
            case 0 : this.province = _R;this.city = [];this.county = []; break
            case 1 : this.city = _R;this.county = []; break
            case 2 : this.county = _R; break
          }
        } else { this._status(res.data) }
      })
    },
    remoteMethod(value, num) {// 清空下级
      switch(num) {
        case 1: this.areaIds[1] = this.areaIds[2] = ''; break;
        case 2: this.areaIds[2]= ''; break;
        case 3: break;
      }
    },
    sendCode() {// 法律咨询表单发送验证码
      let vm = this;
      let phone = vm.layerForm.phoneNumber
      const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (reg.test(phone)) {
        vm.sendCodeBtnSet.disabled = true;//输入的号码格式正确，按钮变为不可点
        this.$api._user_SendCode({phone:phone}).then(res => {
          if (res.data.status === 0) {
            //前端页面效果
            let time = setInterval(function() {
              vm.sendCodeBtnSet.codeTime--
              vm.sendCodeBtnSet.str = '('+vm.sendCodeBtnSet.codeTime+')'+'秒后可重发'
              if (vm.sendCodeBtnSet.codeTime <= 0 ) {
                clearInterval(time)
                vm.sendCodeBtnSet.str = '获取验证码'
                vm.sendCodeBtnSet.disabled = false;
                vm.sendCodeBtnSet.codeTime = 180
              }
            },1000);
          } else { this._status(res.data) }
        })
      } else {
        this.$message.warning('请输入正确的手机号码')
      }
    },
    submitHandler() {// 提交表单
      let vm = this
      let areaIdArr = this.areaIds.filter(x => x)
      if (!areaIdArr.length) {
        this.$message.warning('请选择区域！')
      } else {
        this.layerForm.areaId = areaIdArr[areaIdArr.length-1]//获取区域ID
        let {
          id, // 咨询的律师id
          name, // 咨询的律师姓名
          l_phone, // 咨询的律师姓名
          l_wordAddress, // 咨询的律师姓名
        } = this.layerData

        this.$refs['layerForm'].validate((valid) => {
          if (valid) {//验证通过
            if (this.routeInfo === 'flzx') {
              this.layerForm.l_userId = id
              this.layerForm.l_name = name
              this.layerForm.l_phone = l_phone
              this.layerForm.l_wordAddress = l_wordAddress
              console.log(this.layerForm)

              vm.$api.zixun_create(this.layerForm).then(res => {
                if (res.data.status === 0) {
                  this.$message.success('提交成功!')
                  this.layerForm = {}
                  this.areaIds = []
                } else { this._status(res.data) }
              })
            } else if (this.routeInfo === 'ajwt') {
              this.layerForm.l_userId = id
              this.layerForm.l_name = name
              this.layerForm.phone = this.layerForm.phoneNumber //案件委托人联系电话
              this.layerForm.l_phone = l_phone
              this.layerForm.l_wordAddress = l_wordAddress
              let str = this.$api.imgUrl+'/case/entrust/'+this.layerForm.phoneCode

              vm.$api.weituo_create(this.layerForm).then(res => {
                if (res.data.status === 0) {
                  this.$message.success('提交成功!')
                  this.layerForm = {}
                  this.areaIds = []
                } else { this._status(res.data) }
              })
            }
          } else {
            return false
          }
        })
      }
    },
    //获取评价数据
    getCommentData() {
      let rD = {}
      rD.targetId = this.$route.query.id
      this.scoreIndex === 0 ? '' : rD.score = parseInt(this.pingjiaBtnArr[this.scoreIndex].score)
      rD.pageNumber = this.paging_data.currentPage
      console.log('条件查询评论',rD)
      this.$api.getComment(rD).then(res => {
        if (res.data.status === 0) {
          this.commentData = JSON.parse(res.data.data)
          this.paging_data.total = res.data.size //获取该类数据的总数
          console.log(this.commentData)
        } else { this._status(res.data) }
      })
    },
    //筛选评价
    fifterComment(index) {
      this.scoreIndex = index
    },
    get_page_number(pageNumber) {
      this.paging_data.currentPage = pageNumber
      this.getCommentData()
    },

    
    getLayerData() {//获取律师信息
      let id = this.$route.query.id//通过id获取律师信息
      this.$api.util_search('lvshi', { id }).then(res => {
        if (res.data.status === 0) {
          this.layerData = JSON.parse(res.data.data)[0]
          console.log(this.layerData)

          //设置配置信息
          this.lawyerData.bgImgTopinfo = [//背景图下面的信息
            {label:'办公地址',val:this.layerData.l_wordAddress},
            {label:'电话咨询',val:this.layerData.l_phone},
          ]
          this.lawyerData.home = [//主页信息的配置信息
            {title:'律师简介',label:this.layerData.l_description},
            {title:'成功案例',label:this.layerData.l_case},
          ]
          this.lawyerData.video = [//视频介绍的配置信息
            {title:'视频介绍',videoSrc:this.layerData.videoUrl},
          ]
          this.lawyerData.success = [//成功案列介绍的配置信息
            {title:'成功案例',label:this.layerData.l_case},
          ]
          this.lawyerData.pinjia = [//评价的配置信息
            {title:'用户评价',label:this.layerData.l_case},
          ]
          this.lawyerData.userInfo = [//右边律师基本信息的配置
            {title:'性'+'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+'别',val:this.layerData.l_sex},
            {title:'执业律所',val:this.layerData.l_group},
            {title:'律所规模',val:this.layerData.l_groupPersons},
            {title:'职'+'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+'务',val:this.layerData.l_title},
            {title:'执业证号',val:this.layerData.certNo},
            {title:'执业年份',val:this.layerData.l_startYear},
            {title:'专'+'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+'长',val:this.layerData.l_professional},
            {title:'地'+'\xa0\xa0\xa0\xa0\xa0\xa0\xa0'+'区',val:this.layerData.l_area},
            {title:'位置描述',val:this.layerData.l_locationDesc},
            {title:'服务区域',val:this.layerData.l_serviceArea},
            {title:'办公地址',val:this.layerData.l_wordAddress},
          ]

        } else { this._status(res.data) }
      })
    },
  },
  created() {
    this.areaGet(0, 0)
  },
  beforeRouteEnter(to,from,next) {
    next(vm => {
      vm.navAc = to.query.key
      vm.getLayerData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.lawyerData = {}
    next()
  }
}
</script>

<style lang='scss' scoped>
.navActive{border-bottom: 1px solid #ff6b6b}
.commentBtn{background-color: #F56C6C;color: #fff;}

.Imgbg{height: 500px;display: flex;justify-content: center;align-items: center;background: url(../images/log-reg-bg.jpg) no-repeat center center;margin-bottom: 30px;}
.Imgbg .headbox {text-align: center;margin: auto;}
.Imgbg .headbox .kuang{width: 120px;height: 120px;margin: auto;padding: 15px;background-color: #ffffff;}
.Imgbg .headbox img{width: 120px;height: 120px;}
.Imgbg .headbox .name{font-size: 30px;text-align: center;color: #ffffff;width: 100%;padding: 20px 0;}
.Imgbg .headbox .info{font-size: 14px;color: #ffffff;line-height: 28px;width: 100%;text-align: center;}
.Imgbg .headbox .info span{padding: 0 5px;}

.navBox{height: 50px;line-height: 50px;border: 1px solid #eee;display: flex;justify-content: space-around;margin-bottom: 20px;}
.navBox li{text-align: center;flex: 1;color: #444;}
.navBox li:hover{cursor: pointer;color: #1E9FFF;}

.layerBox{display: flex;justify-content: space-between;}
.layerBox .left{width: 848px;}
.infobox{border: 1px solid #eee;margin-bottom: 15px;}
.infobox .infoTitle{position: relative;height: 50px;line-height: 50px;font-size: 18px;color: #333;padding: 0px 30px;}
.infobox .infoTitle::before{content: "";position: absolute;left: 20px;top: 17px;width: 3px;height: 18px;background-color: #ec0001;}
.infobox .cont{border-top: 1px solid #eee;padding: 15px 25px;font-size: 14px;color: #666;}
.infobox .form{width: 700px;margin: 0px auto;}
.infobox .btninput{width: 200px;}
.infobox .form .areaBox{display: flex;justify-content: space-between;}
.infobox .form .areaBox div{width: 90%;}
.infobox .form .codeinput .input{width: 200px;}
.infobox .form .subBox{margin-left: 80px;}

.layerBox .left .pingjia .commentBox{border: 1px solid #eee;}
.layerBox .left .pingjia .commentBox .title{position: relative;padding: 0px 30px;border-bottom: 1px solid #eee;height: 50px;line-height: 50px;font-size: 18px;color: #333;}
.layerBox .left .pingjia .commentBox .title::before{content: "";position: absolute;left: 20px;top: 17px;width: 3px;height: 18px;background-color: #ec0001;}

.layerBox .left .pingjia .commentBox .btnbox{padding: 20px;border-bottom: 1px solid #eee;}
.layerBox .left .pingjia .commentBox .databox{padding: 20px;}



.layerBox .right{width: 318px;}
.layerBox .right .infobox .cont li{padding: 5px 0;color: #666666;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;font-size: 14px;line-height: 24px;}
.layerBox .right .titlecont{border: 1px solid #eee;margin-bottom: 15px;}
.layerBox .right .titlecont .title{padding-left: 15px;height: 45px;border-bottom: 1px solid #eeeeee;background-color: #f9f9f9;line-height: 45px;}
.layerBox .right .titlecont .contbox{padding: 15px;}
.layerBox .right .titlecont .contbox .text b:hover{color: #1E9FFF;cursor: pointer;}
</style>